import cardValidator from 'card-validator';

export const getCardInfo = card => {
  const data = {};
  if (!card) return data;

  data.cvc = card.cvc;
  data.expiry = card.expiry;

  const num = cardValidator.number(card.number);
  if (num.isValid && num.card && num.card.type) {
    // remove spaces
    data.cardNumber = card.number.replace(/ /g, '');
    // replace hypens with spaces
    data.cardType = num.card.type.replace(/-/g, ' ');
  }
  const expiry = cardValidator.expirationDate(card.expiry);
  if (expiry.isValid) {
    data.cardExpirationMonth = expiry.month;
    if (expiry.year) {
      if (expiry.year.length === 2) {
        data.cardExpirationYear =
          new Date()
            .getFullYear()
            .toString()
            .slice(0, 2) + expiry.year;
      } else {
        data.cardExpirationYear = expiry.year;
      }
    }
  }
  return data;
};
